export const SET_LOADER_SUBTITLE = 'SET_LOADER_SUBTITLE';
export const RESET_LOADER_STATE = 'RESET_LOADER_STATE';
